export default __webpack_public_path__ + "static/media/img-count-0-big.9cc506c9.svg";